import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { TweenMax, TimelineMax, CSSPlugin, Expo } from 'gsap/all';
import DrawSVGPlugin from '../gsap-bonus/DrawSVGPlugin';
import ScrollMagic from 'scrollmagic';


import '../styles/components/details2.scss';


import family from '../assets/family.png';



export default class Details2 extends Component {

    constructor(props) {
      super(props);
      this.dtrigger = null;
      this.dStrokes = [];
      this.family = null;
    }

    componentDidMount() {

      TweenMax.set(this.dStrokes, {
        drawSVG: 0,
        visibility: 'visible'
      })

      TweenMax.set(this.family, {
        opacity: 0
      })

      const familyTl = new TimelineMax({paused: true});
      familyTl.to(this.dStrokes, 1.5, {
        drawSVG: '100%',
        ease: Expo.easeInOut
      })
      .to(this.family, 0.5, {
        opacity: 1
      }, '-=0.125')
      .to(this.dStrokes, 0.5, {
        opacity: 0
      }, '-=0.25')


      const familyController = new ScrollMagic.Controller();
      const familyScene = new ScrollMagic.Scene({
        triggerElement: this.dtrigger,
        triggerHook: "onLeave",
        reverse: true
      }).addTo(familyController);

      familyScene.on("enter", function (event) {
        familyTl.play();
      });
    }

    render() {

        return (
          <div className="details2">
            <span ref={span => this.dtrigger = span} className="dTrigger" />
            <div className="info">
              <span className="smallTitle">VIVE&trade; PRO</span>
              <span className="bigTitle">Game Worlds Come Alive</span>
              <p>VIVE&trade; PRO gets you closer to your game. Heighten your experiences. Enrich your adventures. Let the super-charged VIVE&trade; PRO lead the way.</p>
              <div className="more">
                <span />
                <Link to='/'><p>Learn More</p></Link>
              </div>
            </div>
            <div className="image-group">
              <img ref={img => this.family = img} src={ family } alt='' />
              <svg viewBox="0 0 880.09 405.06">
                <path ref={(dStroke) => { this.dStrokes.push(dStroke) }} d="M719.27,90l68.58,6.43a16.5,16.5,0,0,1,15,16.64l-1,75.92A16.5,16.5,0,0,1,793,203.43l-30.2,15.78a16.5,16.5,0,0,1-10,1.7L684.24,211a16.5,16.5,0,0,1-14.15-16.33V116a16.52,16.52,0,0,1,11.69-15.79l31.13-9.49A16.5,16.5,0,0,1,719.27,90Z" transform="translate(-47.29 -46.93)"/>
                <path ref={(dStroke) => { this.dStrokes.push(dStroke) }} d="M255,90l-68.58,6.42a16.51,16.51,0,0,0-15,16.65l1,75.91a16.51,16.51,0,0,0,8.86,14.42l30.2,15.77a16.5,16.5,0,0,0,10,1.71l68.54-9.9a16.52,16.52,0,0,0,14.15-16.34V116a16.51,16.51,0,0,0-11.7-15.79l-31.13-9.5A16.61,16.61,0,0,0,255,90Z" transform="translate(-47.29 -46.93)"/>
                <path ref={(dStroke) => { this.dStrokes.push(dStroke) }} d="M843.57,354.14c-4,6.63-7.33,18,1.47,33.69,2.93,2.93,13.36,19.87,28.67,13,2.61-1.95,8.8-6.84,2.93-29.65-1.69-4.5-4.83-16.78-19.51-21.93A11.44,11.44,0,0,0,843.57,354.14Z" transform="translate(-47.29 -46.93)"/>
                <path ref={(dStroke) => { this.dStrokes.push(dStroke) }} d="M676.61,283.58s91.87,49.19,107.51,49.52c-.65,8.14-1.63,17.59,6.19,17.26.63,0,4.54.18,5.93-1.82a.21.21,0,0,1,.39.12c.18,4.34,1,17.28-6.81,20.44l-17.59,12.21s-4.56,4.24.49,12.38c2.44,8.64,9.28,31.12,18.4,29.32,9-1.14,20.85-7.49,24.44-3.09s39.52,45.12,78.19,24.92c4.23-2.44,44.47-18.57,28.34-84.54-.65-3.58-7.82-35-45.12-53.92-2.12-1.63-48.71-22-48.71-22s-5-7.82-22.48-5.86c-11.56-4.08-102-30.14-119.24-25.09-4.07.65-21.17,4.72-18.57,18.08C668.63,274.62,667.68,278.85,676.61,283.58Z" transform="translate(-47.29 -46.93)"/>
                <path ref={(dStroke) => { this.dStrokes.push(dStroke) }} d="M131.11,354.19c4,6.63,7.33,18.05-1.47,33.7-2.94,2.93-13.36,19.87-28.67,13-2.61-1.95-8.8-6.84-2.94-29.65,1.69-4.5,4.84-16.78,19.52-21.93A11.44,11.44,0,0,1,131.11,354.19Z" transform="translate(-47.29 -46.93)"/>
                <path ref={(dStroke) => { this.dStrokes.push(dStroke) }} d="M298.07,283.63s-91.87,49.2-107.51,49.53c.65,8.14,1.63,17.59-6.19,17.26-.63,0-4.54.18-5.93-1.82a.21.21,0,0,0-.39.12c-.18,4.33-1,17.28,6.81,20.44l17.59,12.21s4.56,4.24-.49,12.38c-2.44,8.64-9.28,31.12-18.41,29.32-9-1.14-20.85-7.49-24.43-3.09S119.59,465.1,80.93,444.9c-4.24-2.44-44.47-18.57-28.34-84.54.65-3.58,7.82-35,45.12-53.92,2.12-1.63,48.7-22,48.7-22s5.05-7.82,22.48-5.86c11.57-4.08,102-30.14,119.24-25.09,4.08.65,21.18,4.72,18.57,18.08C306.05,274.68,307,278.91,298.07,283.63Z" transform="translate(-47.29 -46.93)"/>
                <path ref={(dStroke) => { this.dStrokes.push(dStroke) }} d="M454.61,76.05a12.64,12.64,0,0,1-3,7.27c-3.57,4.17-11.07,11.07-25.23,17.2-22.16,9.6-34.48,24.47-34.48,24.47s-7.69,5.57-16.62,27.25c-1.19,2.65-6.5,14.33-8.79,19.36a13.56,13.56,0,0,1-3.15,4.35A53.57,53.57,0,0,1,352,184.2a13,13,0,0,0-3.78,2.77c-5.6,6-15.28,19.56-14.46,58.17,0,1.55,3.6,13,0,24.78.66,8.05-2.11,52.95,32.67,67.82,2.46,1.54,17.71,9,42.16,11.14s124,2.79,124,2.79,70.48-4.95,78.79-13c8.31-5.88,33.55-17,32-68.43,0-1.86-2.64-9.6.06-25.71.25-1.85,7.32-34.06-15.45-58.83-1.66-1.44,3.52,4.24-13.26-9a13.56,13.56,0,0,1-4.37-6.14c-4.31-12.27-18.54-50.25-48.85-64.43-3.1-2-25.86-10.74-35.8-23.16a12.26,12.26,0,0,1-2.57-6.76,90.56,90.56,0,0,0-1.77-13.28,1.31,1.31,0,0,0-1.27-1h0a1.27,1.27,0,0,1-.83-.3c-1.53-1.3-8.26-6.5-21.7-10-.11-.87-2.42-4.76-5.08-1.71a.71.71,0,0,1-1.09,0c-1-1.15-2.92-2.4-4.6-.09a.72.72,0,0,1-1.1.09c-1.15-1.24-3.76-2.75-5.21,1.74-2.14.45-17.2,5.09-22.24,9.94a1.75,1.75,0,0,1-.95.49h0a1.69,1.69,0,0,0-1.41,1.47C455.57,65.94,454.94,71.4,454.61,76.05Z" transform="translate(-47.29 -46.93)"/>
                <path ref={(dStroke) => { this.dStrokes.push(dStroke) }} d="M452.49,127.74c-6.1,1.11-50.82,10.14-50.16,37.29a1,1,0,0,0,1.27.89c1-.35,2.21-.82,3.33-1.26a18.38,18.38,0,0,1,6-1.22l38.68-1.27a.55.55,0,0,0,.52-.53l1-33.32A.57.57,0,0,0,452.49,127.74Z" transform="translate(-47.29 -46.93)"/>
                <path ref={(dStroke) => { this.dStrokes.push(dStroke) }} d="M525.13,127.74c6.1,1.11,50.83,10.14,50.16,37.29a1,1,0,0,1-1.27.89c-.95-.35-2.2-.82-3.33-1.26a18.33,18.33,0,0,0-6-1.22L526,162.17a.55.55,0,0,1-.53-.53l-1-33.32A.56.56,0,0,1,525.13,127.74Z" transform="translate(-47.29 -46.93)"/>
                <path ref={(dStroke) => { this.dStrokes.push(dStroke) }} d="M473.11,137.48l-6.6,12.32a.51.51,0,0,0,.06.58l4,4.78a.52.52,0,0,0,.91-.27l2-17.28A.22.22,0,0,0,473.11,137.48Z" transform="translate(-47.29 -46.93)"/>
                <path ref={(dStroke) => { this.dStrokes.push(dStroke) }} d="M497.39,143.67v12.48a.69.69,0,0,0,.69.7h5.3a.7.7,0,0,0,.62-1l-6.19-12.28A.22.22,0,0,0,497.39,143.67Z" transform="translate(-47.29 -46.93)"/>
                <path ref={(dStroke) => { this.dStrokes.push(dStroke) }} d="M498.31,128.29a64.24,64.24,0,0,0,9.45,24.14.81.81,0,0,0,1.36,0c.48-.73,1.07-1.66,1.4-2.18a.82.82,0,0,0,0-.83l-11.81-21.27A.22.22,0,0,0,498.31,128.29Z" transform="translate(-47.29 -46.93)"/>
                <path ref={(dStroke) => { this.dStrokes.push(dStroke) }} d="M481,129.87c-.7,5.2-3,22.16-3.21,26.21a.73.73,0,0,0,.72.77h2a.73.73,0,0,0,.72-.73V129.89A.11.11,0,0,0,481,129.87Z" transform="translate(-47.29 -46.93)"/>
              </svg>
            </div>
          </div>
        );
    }
}
